/**
 * 一次全量：第一次列表响应的业务数据是记录数组，且没有 records、没有总数量。
 * 必须在被包成 {records} 之前判定。
 */
export function isOnceFullListPayload(datas: any): boolean {
  if (datas == null) {
    return false;
  }
  if (Array.isArray(datas)) {
    return true;
  }
  if (typeof datas !== 'object') {
    return false;
  }
  if (datas.records != null || datas.total != null) {
    return false;
  }
  return Array.isArray(datas.data);
}

export function extractOnceFullListRecords(datas: any): any[] {
  if (Array.isArray(datas)) {
    return datas;
  }
  if (datas && Array.isArray(datas.data)) {
    return datas.data;
  }
  if (datas && Array.isArray(datas.records)) {
    return datas.records;
  }
  return [];
}

export function filterOnceFullListRecords(list: any[], keyword: string, dataConfig: any): any[] {
  if (!Array.isArray(list)) {
    return [];
  }
  const raw = (keyword ?? '').toString().trim().toLowerCase();
  if (!raw) {
    return [...list];
  }
  const fields: string[] = [];
  if (dataConfig?.searchKey) {
    fields.push(dataConfig.searchKey);
  }
  const titleId = dataConfig?.titleId;
  if (Array.isArray(titleId)) {
    fields.push(...titleId);
  } else if (titleId) {
    fields.push(titleId);
  }
  fields.push(dataConfig?.keyId || dataConfig?.dateColId || 'id');
  const uniq = [...new Set(fields.filter(Boolean))];
  return list.filter((item) =>
    uniq.some((field) => (item?.[field] + '').toLowerCase().indexOf(raw) >= 0)
  );
}
